/***
 *
 *   Response LAYOUT
 *   Simple layout to focus on user response screens
 *
 **********/

import React, { useEffect, useContext } from "react";
import { ViewContext } from "components/lib";
import Style from "./response.module.scss";

// $c-purple from the SCSS module, repeated here as the inline fallback so an
// un-themed response renders exactly as it always has.
const DEFAULT_BACKGROUND = "#8C66F2";

export function ResponseLayout(props) {
  const context = useContext(ViewContext);
  const brand = context?.brandColor;

  useEffect(() => {
    document.body.classList.add("color");
    return () => {
      document.body.classList.remove("color");
    };
  }, []);

  return (
    <main
      className={Style.campaign}
      style={{
        backgroundImage: brand
          ? `linear-gradient(to bottom, ${brand.from}, ${brand.to})`
          : undefined,
        backgroundColor: brand ? brand.to : DEFAULT_BACKGROUND,
      }}
    >
      {<props.children {...props.data} />}
    </main>
  );
}
